import { CheckoutFormOut, GetReservationDetailsResponse } from '@appTypes/api.types';
import { RequestStateModel } from '@core/store/store.models';

export class CheckoutStateModel {
  calcCheckoutResult = new RequestStateModel<CheckoutFormOut>();
  confirmCheckoutResult = new RequestStateModel<CheckoutFormOut>();
  verifyCalculatedPricesResult = new RequestStateModel<CheckoutFormOut>();
  reservationDetailsData = new RequestStateModel<GetReservationDetailsResponse>();
}
